import React, { memo } from 'react';
import { TraderSellerData } from 'src/pages/delivery-optin/components/kyc/payu/utils/types';
import useI18n from '../../../../i18n/hooks/useI18n';
import DetailsCard from './DetailsCard';
import S from './style/SellerDetails';
import Line from './PriceLine';

interface SellerDetailsProps {
  sellerDetails: TraderSellerData;
}

const SellerDetails = ({ sellerDetails }: SellerDetailsProps) => {
  const currentAddress = Array.isArray(sellerDetails?.addresses)
    ? sellerDetails.addresses[0]
    : undefined;
  const i18n = useI18n();

  return (
    <DetailsCard data-cy="seller-detials" title={i18n`dlv_orders_details_sellerType_title`}>
      <S.BreakBlock>
        <Line
          bold
          code="company-name"
          formattedValue={sellerDetails.name}
          title={i18n`dlv_orders_details_sellerType_label_company_name`}
        />
        <Line
          bold
          code="street"
          formattedValue={currentAddress?.street}
          title={i18n`dlv_orders_details_sellerType_label_street`}
        />
        <Line
          bold
          code="city"
          formattedValue={currentAddress?.city}
          title={i18n`dlv_orders_details_sellerType_label_city`}
        />
        <Line
          bold
          code="postal-code"
          formattedValue={currentAddress?.zipCode}
          title={i18n`dlv_orders_details_sellerType_label_postal_code`}
        />
        <Line
          bold
          code="tax-id"
          formattedValue={sellerDetails.taxId}
          title={i18n`dlv_orders_details_sellerType_label_tax_id`}
        />
        {sellerDetails.email ? (
          <Line
            bold
            code="email"
            formattedValue={sellerDetails.email}
            title={i18n`dlv_orders_details_sellerType_label_email`}
          />
        ) : null}
        {sellerDetails.phone ? (
          <Line
            bold
            code="phone"
            formattedValue={sellerDetails.phone}
            title={i18n`dlv_orders_details_sellerType_label_phone`}
          />
        ) : null}
      </S.BreakBlock>
    </DetailsCard>
  );
};

export default memo(SellerDetails);
